// Get and set the token

const STORAGE_KEY = "auth";

export const setTokenInStorage = ({ username, jwt }) => {
    const storageObject = {
        username: username,
        jwt: jwt,
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(storageObject));
};

export const getTokenFromStorage = () => {
    const storageItem = localStorage.getItem(STORAGE_KEY);
    if (!storageItem) return null;
    return JSON.parse(storageItem);
};

export const removeTokenFromStorage = () => {
    localStorage.removeItem(STORAGE_KEY);
}



// WEBPACK FOOTER //
// ./src/modules/token.js